import * as React from 'react';
import { createElement } from 'react';
import './index.scss';
import { Form, Radio, Input, Field } from '@alifd/next';
import WorkflowActions from './components/workflow-actions';
import request from '@/utils/request';
import { workflowStore } from '@/store';
import { useLocalObservable, observer } from 'mobx-react';
const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const WorkflowOpinionForm = observer((props) => {
    const [commentOptions, setCommentOptions] = React.useState([]);
    const [operationOptions, setOperationOptions] = React.useState([]);
    const { setDocumentId } = useLocalObservable(() => workflowStore);
    const { getFormValues: __getFormValues, validateForms: __validateForms, __designMode, ctx: __ctx, ...otherProps } = props;
    const isDesign = __designMode === 'design';
    const fieldInstance = Field.useField();
    const { taskInstId, type = 'workflow', procInstId, } = __ctx?.appHelper?.constants || {};
    const { tabhelper, } = __ctx?.appHelper?.utils || {};
    const queryTaskConfig = React.useCallback(async () => {
        const { content: { formConfig: { commentOptions: _commentOptions = [], operationOptions: _operationOptions = [], } = {}, comment: _comment = {}, bizDocListId = '' } = {}, } = await request(`/api/process/form/${taskInstId}`);
        setCommentOptions(_commentOptions);
        setOperationOptions(_operationOptions);
        fieldInstance.setValues(_comment);
        setDocumentId(bizDocListId);
    }, [fieldInstance, taskInstId, setDocumentId]);
    React.useEffect(() => {
        if (!isDesign) {
            if (type === 'workflow' || type === 'task') {
                queryTaskConfig();
            }
        }
    }, [isDesign, queryTaskConfig, type]);
    const onChange = (value, items) => {
        const { name, field, value: currentFieldValue } = items;
        switch (name) {
            case 'opinion':
                field.setValue('comment', OpinionMap.find(({ value: v }) => currentFieldValue === v)?.label);
                break;
            default:
                break;
        }
    };
    const getFormValues = () => {
        const values = __getFormValues();
        return values;
    };
    const validateForms = async () => {
        return new Promise((resolve) => {
            __validateForms((err) => {
                if (err) {
                    resolve(false);
                }
                else {
                    resolve(true);
                }
            });
        });
    };
    return (createElement("div", { className: "opinion-container" },
        createElement(Form, { ...otherProps, onChange: onChange, field: fieldInstance, useLabelForErrorMessage: true },
            createElement(FormItem, { name: "opinion", label: "\u5E38\u7528\u5C97\u4F4D\u610F\u89C1" },
                createElement(RadioGroup, null, OpinionMap.filter(({ value }) => commentOptions?.find((v) => v === value))?.map(({ label, value }) => (createElement(Radio, { key: value, value: value }, label))))),
            createElement(FormItem, { name: "comment", label: "\u5C97\u4F4D\u610F\u89C1", required: true },
                createElement(Input.TextArea, null))),
        createElement("div", { className: "actions-wrap" },
            createElement(WorkflowActions, { operationOptions: operationOptions, opinionFormInstance: fieldInstance, validateForms: validateForms, getFormValues: getFormValues, taskInstId: taskInstId, procInstId: procInstId, tabhelper: tabhelper }))));
});
WorkflowOpinionForm.displayName = 'WorkflowOpinionForm';
export default WorkflowOpinionForm;
const OpinionMap = [
    {
        label: '同意',
        value: 'AGREE',
    },
    {
        label: '有条件同意',
        value: 'CONDITIONAL_AGREE',
    },
    {
        label: '不同意',
        value: 'DISAGREE',
    },
    {
        label: '再议',
        value: 'RECONSIDER',
    },
];
